import { isBefore } from 'date-fns';

export default function newLabel (el, { value }) {
  if (isBefore(Date.now(), value)) {
    el.classList.add('new-label-badge');
  } else {
    el.classList.remove('new-label-badge');
  }
}
